import { Constants, MeetingProvider } from "@videosdk.live/react-sdk";
import { useEffect } from "react";
import { useState } from "react";
import { MeetingAppProvider } from "../../MeetingAppContextDef";
import { LeaveScreen } from "../screens/LeaveScreen";
import { JoiningScreenNew } from "../screens/JoiningScreenNew";
import { MeetingContainerNew } from "../../meeting/MeetingContainerNew";
import { MeetingContainerMobile } from "../../meeting/MeetingContainerMobile";
import { useSiteContext } from "../../context/SiteContext";
import { LeaveScreenNew } from "../screens/LeaveScreenNew";
import { WebinarContainer } from "../../meeting/WebinarContainer";
import WebinerBrandingPre from "../webiner-branding/WebinerBrandingPre";
import WebinerBrandingPost from "../webiner-branding/WebinerBrandingPost";
import { useNavigate } from "react-router-dom";
import * as meetingServices from "../../services/meetingServices";
import { BreakoutRoomsProvider } from "../../context/BreakoutRoomsContext";
function Conference() {
  const navigate = useNavigate();
  const { setToken: setTokenContext, setIsAuthenticated, setUser, user, meetingRole, meetingSettings,
    webinarMode, setMeetingRole, setMeetingSettings, isAuthenticated,
    isMeetingReconnecting
  } = useSiteContext();

  const [token, setToken] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [micOn, setMicOn] = useState(false);
  const [webcamOn, setWebcamOn] = useState(false);
  const [customAudioStream, setCustomAudioStream] = useState(null);
  const [customVideoStream, setCustomVideoStream] = useState(null);
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [isMeetingLeft, setIsMeetingLeft] = useState(false);
  const [show, setShow] = useState(false);
  const [joiningToken, setJoiningToken] = useState(null);

  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  const getParticipantId = () => {
    if (!meetingId) return undefined;

    const key = `participant_${meetingId}`;
    let id = sessionStorage.getItem(key);

    if (!id) {
      id = `${user?.id || "guest"}_${crypto.randomUUID()}`;
      sessionStorage.setItem(key, id);
    }

    return id;
  };

  const checkValidMeeting = async (roomName, isauth) => {
    try {
      const response = await meetingServices.getMeetingByName(roomName);
      const meeting = response.meeting;
      // console.log("meeting", meeting);
      if (meeting) {
        // console.log("meeting", meeting);
        if (meeting.scheduledStartTime) {
          meeting.scheduledStartTime = meeting.scheduledStartTime.replace(".000Z", "");
        }
        if (meeting.scheduledEndTime) {
          meeting.scheduledEndTime = meeting.scheduledEndTime.replace(".000Z", "");
        }
        // console.log("meeting123", meeting);
        setMeetingSettings(meeting);
        setMeetingRole(meeting.role);
        setMeetingId(meeting.roomId);
        // console.log("meetingRole", meeting.role);
        const allowGuest = localStorage.getItem("allowguest");
        if (!localStorage.getItem(meeting.roomId)) {
          // generate a random unique alphanumeric string 12 characters long
          const randomString = Math.random().toString(36).substring(2, 15);
          localStorage.setItem(meeting.roomId, randomString);
        }
        // console.log("allowGuest", isauth, allowGuest);
        if (meeting.isNow && !isauth && !allowGuest) {
          console.log("navigate to login");
          localStorage.setItem("roomId", roomName);
          navigate(`/login`);
        } else if (meeting.isNow) {
          const jointokenresp = await meetingServices.getJoiningToken({ roomId: meeting.roomId });
          if (jointokenresp.token) {
            setJoiningToken(jointokenresp.token);
          }
          localStorage.removeItem("roomId");
          localStorage.removeItem("allowguest");
        }
      } else {
        navigate(`/meeting-not-found`);
      }
    } catch (error) {
      console.log("Error in checkValidMeeting", error);
    }
  }

  useEffect(() => {
    const pathname = window.location.pathname;
    const roomName = pathname.split('/').pop();
    const token = localStorage.getItem('token');
    if (token) {
      const inuser = JSON.parse(localStorage.getItem('user'));
      setTokenContext(token);
      setIsAuthenticated(true);
      setUser((prev) => ({
        ...(prev || {}),
        ...(inuser || {}),
      }));
      setShow(true);
      console.log("user", inuser);
      setParticipantName(inuser?.name);
      checkValidMeeting(roomName, true);
    } else {
      checkValidMeeting(roomName, false);
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
  }, [isMobile]);

  const meetingMode = () => {
    if (meetingSettings && meetingSettings.roomType == "Webinar" && meetingRole == "participant") {
      return Constants.modes.RECV_ONLY;
    } else {
      return Constants.modes.SEND_AND_RECV;
    }
  }

  return (
    <>
      {show && meetingSettings?.isNow && <MeetingAppProvider>
        {isMeetingStarted && webinarMode ? (
          <MeetingProvider
            config={{
              meetingId,
              participantId: user?.id || (localStorage.getItem(meetingId) || Math.random().toString(36).substring(2, 15)),
              //  participantId: getParticipantId(),
              micEnabled: micOn,
              webcamEnabled: webcamOn,
              name: participantName ? participantName : "No Name",
              multiStream: true,
              metaData: {
                profileImage: user?.logo,
                meetingRole: meetingRole,
                userId: user?.id,
                deviceType: isMobile ? "mobile" : "desktop",
                isMobile: !!isMobile,
              },
              permissions: {
                removeParticipant: meetingRole && meetingRole == "moderator",
              },
              mode: webinarMode,
              translationLanguage: "en",
              // speakingLanguage: "en",
            }}
            token={joiningToken}
            reinitialiseMeetingOnConfigChange={true}
            joinWithoutUserInteraction={true}
          >
            <BreakoutRoomsProvider>
              {meetingSettings && meetingSettings.roomType == "Meeting" && !isMobile && <MeetingContainerNew
                onMeetingLeave={() => {
                  setToken("");
                  setMeetingId("");
                  setParticipantName("");
                  setWebcamOn(false);
                  setMicOn(false);
                  setMeetingStarted(false);
                  // redirect to leave screen
                  if (meetingSettings?.exitUrl && meetingSettings.exitUrl != "false") {
                    window.location.href = meetingSettings.exitUrl;
                  } else {
                    setIsMeetingLeft(true);
                  }
                }}
                setIsMeetingLeft={setIsMeetingLeft}
                setCustomVideoStream={setCustomVideoStream}
                micOn={micOn}
                setMicOn={setMicOn}
                webcamOn={webcamOn}
                setWebcamOn={setWebcamOn}
                customAudioStream={customAudioStream}
                setCustomAudioStream={setCustomAudioStream}
                customVideoStream={customVideoStream}
              />}
              {meetingSettings && meetingSettings.roomType == "Meeting" && isMobile && <MeetingContainerMobile
                onMeetingLeave={() => {
                  setToken("");
                  setMeetingId("");
                  setParticipantName("");
                  setWebcamOn(false);
                  setMicOn(false);
                  setMeetingStarted(false);
                }}
                setIsMeetingLeft={setIsMeetingLeft}
                setCustomVideoStream={setCustomVideoStream}
                micOn={micOn}
                setMicOn={setMicOn}
                webcamOn={webcamOn}
                setWebcamOn={setWebcamOn}
                customAudioStream={customAudioStream}
                setCustomAudioStream={setCustomAudioStream}
                customVideoStream={customVideoStream}
              />}
              {meetingSettings && meetingSettings.roomType == "Webinar" && <WebinarContainer
                onMeetingLeave={() => {
                  setToken("");
                  setMeetingId("");
                  setParticipantName("");
                  setWebcamOn(false);
                  setMicOn(false);
                  setMeetingStarted(false);
                }}
                setIsMeetingLeft={setIsMeetingLeft}
                setCustomVideoStream={setCustomVideoStream}
                micOn={micOn}
                setMicOn={setMicOn}
                webcamOn={webcamOn}
                setWebcamOn={setWebcamOn}
                customAudioStream={customAudioStream}
                setCustomAudioStream={setCustomAudioStream}
                customVideoStream={customVideoStream}
              />
              }
            </BreakoutRoomsProvider>
          </MeetingProvider>
        ) : isMeetingLeft ? (
          <LeaveScreenNew setIsMeetingLeft={setIsMeetingLeft} meetingId={meetingId} />
        ) : (
          <JoiningScreenNew
            participantName={participantName}
            setParticipantName={setParticipantName}
            setMeetingId={setMeetingId}
            meetingId={meetingId}
            setToken={setToken}
            micOn={micOn}
            setMicOn={setMicOn}
            webcamOn={webcamOn}
            setWebcamOn={setWebcamOn}
            customAudioStream={customAudioStream}
            setCustomAudioStream={setCustomAudioStream}
            customVideoStream={customVideoStream}
            setCustomVideoStream={setCustomVideoStream}
            onClickStartMeeting={() => {
              setMeetingStarted(true);
            }}
            startMeeting={isMeetingStarted}
            setIsMeetingLeft={setIsMeetingLeft}
            joiningToken={joiningToken}
            setJoiningToken={setJoiningToken}
          />
        )}
      </MeetingAppProvider>}
      {meetingSettings && !meetingSettings?.isNow && show &&
        (<>
          {!meetingSettings?.isPast && <WebinerBrandingPre />}
          {meetingSettings?.isPast && <WebinerBrandingPost />}
        </>
        )
      }
      {isMeetingReconnecting && (
        <div className="fixed inset-0 bg-[#00000014] backdrop-blur-sm z-[9999] flex items-center justify-center animate-fadeIn">
          <div className="flex flex-col items-center justify-center gap-6 p-8 rounded-2xl backdrop-blur-md shadow-2xl border animate-scaleIn" style={{ backgroundColor: '#7700ff7a', borderColor: 'rgba(98, 70, 251, 0.5)' }}>
            {/* Animated Spinner */}
            <div className="relative w-20 h-20">
              <div className="absolute inset-0 border-4 border-gray-700 rounded-full"></div>
              <div className="absolute inset-0 border-4 border-transparent rounded-full animate-spin" style={{ borderTopColor: '#6246FB' }}></div>
              <div className="absolute inset-0 border-4 border-transparent rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s', borderRightColor: '#586FEA' }}></div>
              <div className="absolute inset-2 border-4 border-transparent rounded-full animate-spin" style={{ animationDuration: '2s', borderBottomColor: '#4F63D2' }}></div>
            </div>

            {/* Pulsing Dots */}
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full animate-pulse" style={{ animationDelay: '0s', backgroundColor: '#6246FB' }}></div>
              <div className="w-3 h-3 rounded-full animate-pulse" style={{ animationDelay: '0.2s', backgroundColor: '#586FEA' }}></div>
              <div className="w-3 h-3 rounded-full animate-pulse" style={{ animationDelay: '0.4s', backgroundColor: '#4F63D2' }}></div>
            </div>

            {/* Text */}
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-white text-2xl md:text-3xl font-bold tracking-wide animate-pulse">
                Reconnecting
              </h2>
              <p className="text-gray-300 text-sm md:text-base font-medium">
                Please wait while we restore your connection...
              </p>
            </div>

            {/* Progress Bar Animation */}
            <div className="w-64 h-1 bg-gray-700 rounded-full overflow-hidden">
              <div className="h-full rounded-full animate-progress" style={{ background: 'linear-gradient(to right, #6246FB, #586FEA, #4F63D2)' }}></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Conference;
